(() => {
  // app/scripts/lazy-menu.js
  var LazyMenu = class extends HTMLElement {
    constructor() {
      super();
      this._isLoaded = false;
    }
    connectedCallback() {
      if (!this._isLoaded) {
        this.style.display = "none";
        this._isLoaded = true;
      }
    }
    showAndReplace() {
      this.style.display = "";
      const details = this.closest("details.js-mega-nav");
      if (!details) return;
      while (this.firstChild) {
        details.insertBefore(this.firstChild, this);
      }
      this.remove();
    }
  };
  customElements.define("lazy-menu", LazyMenu);
})();
